// removed by extract-text-webpack-plugin
module.exports = {"racersList":"_1bJKoGISTW2v8Pxz3dJJhX","racersColumn":"_3i1id0b6zePkNMGtbzrwSz"};


//////////////////
// WEBPACK FOOTER
// ./src/ui-modules/simplified/mobile/modules/racing/css/simpleRacersList.css
// module id = 1002
// module chunks = 0